var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upgrade_tip_wrap"},[_c('div',{staticClass:"upgrade_title"},[_vm._v("提示")]),_c('div',{staticClass:"upgrade_tips_content"},[_vm._v("抱歉，当前为"+_vm._s(_vm.versionText)+"及以上版本功能，请升级后使用")])])
}
var staticRenderFns = []

export { render, staticRenderFns }